var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareWithAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.974,
    height: 11.973,
    viewBox: "0 0 11.974 11.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share-_1099_",
    "data-name": "share-[#1099]",
    d: "M373.579,3166.112a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2Zm-5.3,1a2.119,2.119,0,0,0-1.283-.844v-2.562a2.243,2.243,0,0,0,1.352-.928l2.887,1.664a2.357,2.357,0,0,0,.005.964Zm-1.879,2.664a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2Zm-1.2-8.381a1.241,1.241,0,0,1,1.2-1.2,1.205,1.205,0,1,1,0,2.394,1.241,1.241,0,0,1-1.2-1.2Zm8.383,1.125a2.362,2.362,0,0,0-1.816.85l-3-1.73a2.389,2.389,0,1,0-4.766-.245,2.224,2.224,0,0,0,1.795,2.311v2.562a2.224,2.224,0,0,0-1.795,2.311,2.391,2.391,0,1,0,4.754-.359l3.027-1.742a2.389,2.389,0,1,0,1.8-3.957Z",
    transform: "translate(-364 -3159)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWithAllIcon);
export default __webpack_public_path__ + "static/media/share-with-all-icon.e967ca1371c4a43fafe5a88bb9b63755.svg";
export { ForwardRef as ReactComponent };